import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
export class CreateSimilarIconButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domainObject: props.onClick,
      onClick: props.onClick,
      caption: props.caption,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        className="createSimilar"
        onClick={this.onClick.bind(this)}
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          float: "right",
          marginRight: "3px",
          // paddingTop: "5px",
          display: "flex",
        }}
      >
        <Button
          variant="contained"
          size="small"
          style={{
            background: "#6A7B8E",
            color: "#fff",
            marginRight: "1rem",
            float: "right",
          }}
          onClick={this.onClick.bind(this)}
          startIcon={<ControlPointDuplicateIcon />}
        >
          {this.props.name}
        </Button>
      </span>
    );
  }
}
export default CreateSimilarIconButton;
